import {FC, useRef, useState} from 'react'
import {getRed, getGreen, getYellow, containsCoord} from "../../lib/chip-marker";
import {InsuranceVTR} from "../../types";

interface Props {
    vtrInsurance?: InsuranceVTR
}

const InsuranceInfo: FC<Props> = ({ vtrInsurance}) => {

    if(!vtrInsurance)
        return

    return (
        <div className={"input-outer col-lg-12"}>
            <div className={"vtr-insurance"}>
                <div className={"vtr-insurance__header"}>
                    Försäkring/prisförslag
                </div>
                <div className={"vtr-insurance__content"}>
                    Försäkringsbolag: <span className={"vtr-insurance__value"}>{vtrInsurance.insurance_company}</span>
                    <div className={"vtr-insurance__crack"}>
                        Uppskattat pris/självrisk: <span className={"vtr-insurance__value"}>{vtrInsurance.cost && vtrInsurance.cost.window_change ? vtrInsurance.cost.window_change : 'Uppgift saknas'}</span>
                    </div>
                    <div className={"vtr-insurance__chip"}>
                        Uppskattat pris/självrisk: <span className={"vtr-insurance__value"}>{vtrInsurance.cost && vtrInsurance.cost.chip_repair ? vtrInsurance.cost.chip_repair : 'Uppgift saknas'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default InsuranceInfo
